/**
 *
 * DomesticShipmentNotAllowed
 *
 */

import React from "react";
import PropTypes from "prop-types";
import { DhlText, DhlButton, DhlLink } from "@dhl-official/react-library";
import { Variants } from "@dhl-official/stencil-library";
import { injectIntl } from "react-intl";
import { Icon, Headline, ContentModal } from "root/libs/ui-components/src";
import { SEGMENT_TYPES } from "one-time-shipment/src/containers/SpotShipmentPage/constants";
import { breakpoints } from "root/libs/ui-styleguide/src";
import fastDeliveryIcon from "iconsTwoColors/cx/fast-delivery.svg";
import styled from "styled-components";

const Content = styled.div`
  width: 100%;
  height: 100%;
`;

const StyledIcon = styled(Icon)`
  margin: 0 auto;
  margin-bottom: 20px;
`;

const LinkCTA = styled(DhlLink)`
  & dhl-button a {
    margin: 0 auto var(--dui-size-space-10x) auto;
  }
`;

const CopyContainer = styled.div`
  text-align: center;
  margin: var(--gaq-size-space-50px) 0 var(--gaq-size-space-50px) 0;

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin: var(--dui-size-space-20x) 0 var(--gaq-size-space-50px) 0;
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    margin: var(--dui-size-space-20x) 0 var(--gaq-size-space-30px) 0;
  }
`;

const CopyText = styled(DhlText)`
  display: block;
  & > *:is(p, span) {
    margin-bottom: 20px;
    text-align: center;
  }
`;

const COPY_ID_PREFIX = "DomesticShipmentNotAllowed";

const DomesticShipmentNotAllowed = (props) => {
  const { intl, onClose, isDomesticShippingAvailable } = props;
  const ctaExists = !!intl.messages[`${COPY_ID_PREFIX}.ctaText`];

  function getSegmentName(isDomesticShippingAvailableParam) {
    let segmentName;

    if (isDomesticShippingAvailableParam.private) {
      segmentName = {
        id: SEGMENT_TYPES.private,
      };
    } else if (isDomesticShippingAvailableParam.business) {
      segmentName = { id: SEGMENT_TYPES.business };
    } else {
      segmentName = undefined;
    }
    return segmentName;
  }

  return (
    <ContentModal
      {...props}
      closeButtonAriaLabel={intl.formatMessage({ id: "SS.ContentModal.close" })}
      contentAriaLabel={intl.formatMessage({
        id: `${COPY_ID_PREFIX}.headline`,
      })}
      onClose={onClose}
      smallCenteredModal
      variant="bottom"
    >
      <Content>
        <CopyContainer>
          <StyledIcon
            fillColor="var(--dui-color-red-500)"
            icon={fastDeliveryIcon}
            useAs="decorative"
            width={{ mobile: "108px", desktop: "108px" }}
            height={{ mobile: "64px", desktop: "64px" }}
            extraStyles={[{ margin: "0 auto" }]}
          />
          <Headline priority={2} headlineDisplayType="h" weight="700">
            {intl.formatMessage({
              id: `${COPY_ID_PREFIX}.headline`,
            })}
          </Headline>
          <CopyText doubleBottomSpacing isParagraph>
            {intl.formatMessage({
              id: `${COPY_ID_PREFIX}.description`,
            })}
          </CopyText>
          <LinkCTA
            href={intl.formatMessage({
              id: `${COPY_ID_PREFIX}.linkUrl`,
            })}
            variant={Variants.primary}
            dataTestid="create-shipment-profile-cta"
          >
            {intl.formatMessage({
              id: `${COPY_ID_PREFIX}.linkText`,
            })}
          </LinkCTA>
          {ctaExists && (
            <DhlButton
              name="ship-domestic-cta"
              dataTestid="ship-domestic-cta"
              variant={Variants.outline}
              type="button"
              clickEvent={() =>
                onClose({
                  segment: getSegmentName(isDomesticShippingAvailable),
                })
              }
            >
              {intl.formatMessage({ id: `${COPY_ID_PREFIX}.ctaText` })}
            </DhlButton>
          )}
        </CopyContainer>
      </Content>
    </ContentModal>
  );
};

DomesticShipmentNotAllowed.propTypes = {
  intl: PropTypes.any.isRequired,
  onClose: PropTypes.func,
  isDomesticShippingAvailable: PropTypes.shape({
    private: PropTypes.bool,
    business: PropTypes.bool,
  }),
};

DomesticShipmentNotAllowed.defaultProps = {
  onClose: () => {},
};

export default injectIntl(DomesticShipmentNotAllowed);
